import React from "react";

/**Ant-design */
import { Modal } from "antd";

import "./ContenidoVacanteModal.css";
import { ContenidoVacantes } from "./ContenidoVacantes";


export const ContenidoVacanteModalComponent = ({showModalContenidoVacante, showModalContenidoVacanteFunction}) => {
    return ( 
        
            <>
                <Modal 
                    mask={false}
                    maskClosable={false}
                    className="ContenidoVacantesModal"
                    title={<>&nbsp;</>} 
                    visible={showModalContenidoVacante} 
                    onCancel={showModalContenidoVacanteFunction}
                    footer={[<></>]}
                >
                    <ContenidoVacantes/>               
                </Modal>
            </>
        
    );
}